import type { ChartCurve } from './types'
import {
	catmullRomSpline,
	easeOutCubic,
	linearPath,
	smoothPath,
	stepPath,
	type CurvePoint,
} from '@schmancy/utils/curves'

// The curve math itself lives in @schmancy/utils/curves (a
// dependency of both @schmancy/primitives and @schmancy/directives — see
// that file's header for why). Re-exported here so every existing consumer
// of this module keeps working unchanged; `buildCurve` below is the one
// piece that's genuinely chart-specific (dispatch on a chart's own
// `ChartCurve` config) and stays local.
export type { CurvePoint }
export { catmullRomSpline, easeOutCubic, linearPath, smoothPath, stepPath }

/** Dispatches to the path builder matching a chart's `curve` config. */
export function buildCurve(curve: ChartCurve, points: CurvePoint[]): CurvePoint[] {
	if (curve === 'step') return stepPath(points)
	if (curve === 'smooth') return smoothPath(points)
	return linearPath(points)
}
